/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasContact } from '../../models/OasContact';

/**
 * Constructor.
 * @class
 * @extends OasContact
 * @author eric.wittmann@gmail.com
 */
export class Oas20Contact extends OasContact {
    public constructor() {
        super();
    }
}
Oas20Contact["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20Contact";
Oas20Contact["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




